// Mock paper data for testing
import { Paper } from "../types/paper";

export const mockPapers: Paper[] = [
  {
    id: "paper-001",
    title: "Deep Learning for Natural Language Processing: A Survey",
    authors: ["Smith, John", "Johnson, Emily", "Williams, Robert"],
    year: 2023,
    journal: "Journal of Machine Learning Research",
    doi: "10.1234/jmlr.2023.001",
    abstract: "A comprehensive survey of deep learning techniques in NLP...",
  },
  {
    id: "paper-002",
    title: "The Impact of Social Media on Academic Research",
    authors: ["Brown, Sarah"],
    year: 2022,
    journal: "Nature Communications",
    doi: "10.1038/s41467-022-12345",
    abstract: "This study examines how social media platforms affect research dissemination...",
  },
  {
    id: "paper-003",
    title: "Quantum Computing: Current State and Future Prospects",
    authors: ["Davis, Michael", "Garcia, Maria"],
    year: 2024,
    journal: "Science",
    doi: "10.1126/science.abc1234",
    abstract: "We review recent advances in quantum computing hardware and algorithms...",
  },
  {
    id: "paper-004",
    title: "Climate Change and Biodiversity Loss: A Global Assessment",
    authors: ["Anderson, Lisa", "Taylor, James", "Martinez, Carlos"],
    year: 2023,
    journal: "Environmental Research Letters",
    doi: "10.1088/1748-9326/abc123",
    abstract: "A global assessment of biodiversity trends under climate change scenarios...",
  },
  {
    id: "paper-005",
    title: "CRISPR Gene Editing: Ethical Considerations and Future Directions",
    authors: ["Wilson, Jennifer"],
    year: 2024,
    journal: "Cell",
    doi: "10.1016/j.cell.2024.01.001",
    abstract: "We discuss the ethical implications of CRISPR technology in human medicine...",
  },
];
